import dayjs from 'dayjs';

export const utcConverterISOString = (dayjsDate) => {
	const toISOString = dayjs(dayjsDate).toISOString();

	const utcDate = dayjs?.utc(toISOString);

	return utcDate.add(6, 'hour');
};

export const utcConverter = (dayjsDate) => {
	if (!dayjsDate) return null;

	// Check if it's a dayjs object, if not try to convert it
	const date = dayjs.isDayjs(dayjsDate) ? dayjsDate : dayjs(dayjsDate);

	// Now use format safely
	const dateStr = date.format('YYYY-MM-DD');
	return dayjs.utc(dateStr, 'YYYY-MM-DD');
};

export const processArrays = (grossRents = [], advanceAmounts = []) => {
	// Store original lengths
	const originalGrossRentsLength = grossRents?.length;
	const originalAdvanceAmountsLength = advanceAmounts?.length;

	// Calculate effective length
	const effectiveLength = Math.max(originalGrossRentsLength, originalAdvanceAmountsLength);

	// Create copies of the original arrays
	const paddedGrossRents = [...grossRents];
	const paddedAdvanceAmounts = [...advanceAmounts];

	// Pad the shorter array with zeros
	if (originalGrossRentsLength < effectiveLength) {
		paddedGrossRents.push(...Array(effectiveLength - originalGrossRentsLength).fill(0));
	}

	if (originalAdvanceAmountsLength < effectiveLength) {
		paddedAdvanceAmounts.push(...Array(effectiveLength - originalAdvanceAmountsLength).fill(0));
	}

	// Return the results
	return {
		processedGrossRents: paddedGrossRents,
		processedAdvanceAmounts: paddedAdvanceAmounts,
		effectiveLength: effectiveLength,
		effectiveAdvanceDuration: originalAdvanceAmountsLength,
	};
};
